import { useQuery } from "react-query";
import axiosInstance from "./axiosInstance";
import { updateContactListRes } from "../Slices/ContactListSlice";
import { useAppDispatch } from "../../utils/hooks";
import { ContactListRes } from "../../types/ResType";

export const useContactList = (options?: { enabled?: boolean }) => {
  const dispatch = useAppDispatch();
  return useQuery<ContactListRes, Error>(
    ["contacts/get-contacts"],
    async () => {
      const response = await axiosInstance.get<ContactListRes>("contacts/get-contacts");
      dispatch(updateContactListRes(response.data));
      return response.data;
    },
    {
      staleTime: Infinity,
      cacheTime: Infinity,
      enabled: options?.enabled ?? true,
    },
  );
};
